export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://www.yovolumy.shop";

// export const STORY_URL = "https://bmwstory.efraincy.life";
export const STORY_URL = "https://story.bmw-fr.it.com";
// export const STORY_URL = "https://story.uk-bmw.com";

export const url =
  window.location.host.indexOf("localhost") < 0
    ? window.location.host
    : "www.yovolumy.shop";

export default {
  STORY_LIST: "/api/Tiezi/getTiezilistN",
  STORY_DETAIL: "/api/Tiezi/getTiezi",
  COMMENT_LIST: "/api/Pinglun/getPinglunlisttieziN",
  UPLOAD: "/api/common/upload",
  GET_PIXEL: "/api/index/getpixel",
  FACEBOOK: "/api/facebook/EventsAll",
  SUBMIT: "/api/index/index",
  UPDATE: "/api/index/updateOrder",
  CUSTOMSTATUS: "/api/index/customstatus",
  ADDRESS: "/api/jpaddress/address",
  GET_PK: "/api/index/get_pk",
  PAY1: "/api/index/index1",
  POST_MESSAGE: "/api/index/send_kf_2",
  GET_IP: "/api/index/getIp",
  GET_COUNTRY: "/api/index/getCountry",
};

export const DEFAULT_PIXEL_ID = "1378681159515837";
export const DEFAULT_FBQ_TOKEN =
  "EAAPSL7YbIKYBO4XVUQhPEYjIRcWaH6LwcEL6mEhmod7wzhtTlYC3QoDkc1ZBIDGVZBnHxKWT1hZCPMKO4qxWYZAQZCg8JYav4sRywVWgQvKmZCQiPhkYC99UP9fWI9oZBq3JcYG1K1qoNtnH7OsPi7ZATTsZCOgn41oJL6fguBN3ZBXZBvhPRgcm8Ri4Xfnw3x8MmY36AZDZD";
export const DEFAULT_CONTENT_IDS = ["stay_work"];
export const DEFAULT_CONTENT_TYPE = "job";
export const DEFAULT_CONTENTS_TITLE = "stay_work";
export const DEFAULT_CONTENTS_TITLE_2 = "stay_work";
export const PRODUCT_NAME = "stay_work";

export const POST_MEASSGE_GROUP_ID = "-5183018982";
export const currency = "SGD";
